import { Component, OnInit } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false
})
export class DashboardComponent implements OnInit {
  userName: string;
  loadedComplete = false;
  sectionLoadStatus: { [key: string]: boolean } = {
    inProgress: false,
    credentials: false,
    tasks: false,
    cta: false
  };
  constructor(private oidcSecurityService: OidcSecurityService) {}

  async ngOnInit() {
    this.oidcSecurityService.getUserData().subscribe((userData) => {
      this.userName = userData?.given_name;
    });
  }

  onLoadedComplete(section: string): void {
    this.sectionLoadStatus[section] = true;
    this.loadedComplete = Object.values(this.sectionLoadStatus).every((status) => status);
  }
}
